import type { EstadoF11 } from '../asistencia/f11/i18n'

const token = (c: string) => c.toLowerCase()

export const ESTADO_F11_COLOR: Record<EstadoF11, { bg: string; fg: string }> = Object.fromEntries(
  (['1', 'EM', 'RC', 'VA', 'LS', 'EN', 'TR', 'EX', 'OT', 'NJ'] as EstadoF11[]).map((c) => [
    c,
    { bg: `var(--color-estado-f11-${token(c)})`, fg: `var(--color-estado-f11-${token(c)}-fg)` },
  ]),
) as Record<EstadoF11, { bg: string; fg: string }>

export const ESTADO_F11_ICONO: Record<EstadoF11, string> = {
  '1': '✓',
  EM: '⇄',
  RC: '↻',
  VA: '☀',
  LS: '✚',
  EN: '☹',
  TR: '⚒',
  EX: '✎',
  OT: '?',
  NJ: '✕',
}
